import React, { Component } from 'react';
import {
  Form,
  Input,
  Label,
  Button,
  SelectTags
} from '../../../Form';

import withTranslations from '../../../../utils/translations/withTranslations';

class Skeleton extends Component {
  constructor(...props) {
    super(...props);

    this.state = {
      isValid: true
    };
  }

  next() {
    this.props.saveItem(this.form.formData());
    this.props.next();
  }

  render() {
    const { translate, data = {}, previous } = this.props;
    const { isValid } = this.state;

    return (
      <div className="Skeleton">
        <Form
          ref={form => (this.form = form)}
          onValidationChange={valid => this.setState({ isValid: valid })}
          className="Skeleton__Form"
        >
          <h1>{translate('fiche.skeleton.title')}</h1>
          <Label text={translate('fiche.skeleton.vertebral_column')} />
          <SelectTags
            name="vertebral_column"
            tags={translate('fiche.skeleton.vertebral_column_items')}
            defaultValue={data.vertebral_column}
          />

          <Label text={translate('fiche.skeleton.hernia')} />
          <Input
            name="hernia"
            rules={['required']}
            defaultValue={data.hernia}
          />

          <h2>{translate('fiche.skeleton.joints')}</h2>

          <Label text={translate('fiche.skeleton.shoulders')} />
          <Input
            name="shoulders"
            rules={['required']}
            defaultValue={data.shoulders}
          />

          <Label text={translate('fiche.skeleton.wrists')} />
          <Input
            name="wrists"
            rules={['required']}
            defaultValue={data.wrists}
          />

          <Label text={translate('fiche.skeleton.knees')} />
          <Input
            name="knees"
            rules={['required']}
            defaultValue={data.knees}
          />

          <Label text={translate('fiche.skeleton.ankles')} />
          <Input
            name="ankles"
            rules={['required']}
            defaultValue={data.ankles}
          />

          <Button
            solid
            className="Form__Button"
            disabled={!isValid}
            onClick={() => this.next()}
          >
            {translate('fiche.next')}
          </Button>
          <Button
            transparant
            className="Form__Button"
            onClick={() => previous()}
          >
            {translate('fiche.previous')}
          </Button>
        </Form>
      </div>
    );
  }
}

export default withTranslations(Skeleton);
